<div class="animation-inner-container">
    <div class="animation-wrapper">
        <ng-lottie [options]="lottieOptions || { path: path }"></ng-lottie>
    </div>
</div>
